import React from "react";

import '../styles/components/Footer.css'

import logo from "../assets/images/desktop/logo.png";
import twitter from "../assets/images/icons/twitter.png";
import linkedin from "../assets/images/icons/linkedin.png";
import google from "../assets/images/icons/google.png";
import fb from "../assets/images/icons/fb.png";

const Footer = () => {

    return (
        <>
            <footer className='footer'>
                <div className='footer-div'>
                    <div className='head'>
                        <img src={logo} alt='logo'/>
                        <h1>رائد أعــمال بدأت عدة أعمال
                            تجارية ناجحة ومستمرة للآن</h1>
                        <div className='icons'>
                            <div className='image'>
                                <img className='twitter' src={twitter} alt='twitter'/>
                            </div>
                            <div className='image'>
                                <img className='linkedin' src={linkedin} alt='linkedin'/>
                            </div>
                            <div className='image'>
                                <img className='google' src={google} alt='google'/>
                            </div>
                            <div className='image'>
                                <img className='fb' src={fb} alt='facebook'/>
                            </div>
                        </div>
                    </div>
                    <div className='links' style={{display: 'none'}}>
                        <h2>روابـــط</h2>
                        <ul>
                            <a className="link" href="/">الصفحة الرئيسية</a>
                            <a className="link" href="/about">من أنا</a>
                            <a className="link" href="/blog">المدونة</a>
                            <a className="link" href="/contact">تواصل معي</a>
                        </ul>
                    </div>
                    <div className='to-contact'>
                        <h2>التواصـــل</h2>
                        <div className='infos'>
                            <p className='address'>المكان:  123 Fifth Avenue,New York, NY 10160</p>
                            <p className='email'>البريد:  contact@hello.com</p>
                            <p className='phone'>الهاتف:  +1 910-626-85255</p>
                        </div>
                    </div>
                </div>
                <div className='copyright'>
                    <span>Copyright©2022</span>
                    <span>Powered by Vamill</span>
                </div>
            </footer>
        </>
    )

}

export default Footer